import { z } from "zod";

export const cruSchema = z.enum(["grand_cru", "premier_cru", "autre"]);
export type Cru = z.infer<typeof cruSchema>;
export const CRU_LABELS: Record<Cru, string> = {
  grand_cru: "Grand Cru",
  premier_cru: "Premier Cru",
  autre: "Sans mention Grand/Premier Cru",
};
export const choixCruParcelleSchema = z.discriminatedUnion("mode", [
  z
    .object({
      mode: z.literal("automatique"),
      notes: z.string().trim().max(4000).nullable().optional(),
    })
    .strict(),
  z
    .object({
      mode: z.literal("manuel"),
      valeur: cruSchema.nullable(),
      notes: z.string().trim().max(4000).nullable().optional(),
    })
    .strict(),
]);
export type ChoixCruParcelle = z.infer<typeof choixCruParcelleSchema>;
export interface ProjectionCruParcelle {
  valeur: Cru | null;
  mode: "automatique" | "manuel";
  suggestion: Cru | null;
  qualification_suggestion: "non_ambigue" | "a_preciser" | "non_documentee";
  a_revoir: boolean;
}

/** Déclaration de parcelle et suggestion de commune, sans certification d'une étiquette. */
export function projeterCruParcelle(
  parcelle: {
    commune_insee: string;
    cru_mode: string;
    cru_manuel: string | null;
    cru_contexte_commune_insee: string | null;
  },
  commune: { cru: string; qualification_suggestion: string } | null,
): ProjectionCruParcelle {
  const qualification =
    commune?.qualification_suggestion === "non_ambigue"
      ? "non_ambigue"
      : commune?.qualification_suggestion === "a_preciser"
        ? "a_preciser"
        : "non_documentee";
  const parse = (value: string | null | undefined): Cru | null => {
    const result = cruSchema.safeParse(value);
    return result.success ? result.data : null;
  };
  const suggestion = qualification === "non_ambigue" ? parse(commune?.cru) : null;
  const manuel = parcelle.cru_mode === "manuel";
  return {
    valeur: manuel ? parse(parcelle.cru_manuel) : suggestion,
    mode: manuel ? "manuel" : "automatique",
    suggestion,
    qualification_suggestion: qualification,
    a_revoir: manuel && parcelle.cru_contexte_commune_insee !== parcelle.commune_insee,
  };
}
